import { useEffect } from 'react';
import { isAdaptiveActive } from '../../../helpers/ElementHelpers';

export const usePickerEventListeners = (
    setShow: (show: boolean) => void,
    ) => {

    const onResize = () => {
        if (isAdaptiveActive()) return;
        setShow(false);
    }

    useEffect(() => {
        window.addEventListener("resize", onResize);
        return (() => {
            window.removeEventListener("resize", onResize);
        })
    }, []);
};
